import { render, staticRenderFns } from "./faqs.vue?vue&type=template&id=2806def0&scoped=true&"
import script from "./faqs.vue?vue&type=script&lang=js&"
export * from "./faqs.vue?vue&type=script&lang=js&"
import style0 from "./faqs.vue?vue&type=style&index=0&id=2806def0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806def0",
  null
  
)

export default component.exports